import { Component, EventEmitter, Input, Output } from "@angular/core";

export type MedNotificationType = "error" | "success" | "info";

@Component({
  selector: "med-notification-container",
  templateUrl: "./med-notification-container.component.html",
  styleUrls: ["./med-notification-container.component.scss"],
})

export class MedNotificationContainerComponent {
  @Input() type: MedNotificationType = "info";
  @Input() showCloseAction = true;
  @Output() close = new EventEmitter();

  get classList(): string {
    return this.type;
  }

  get isSuccess(): boolean {
    const SUCCESS_STATUS = "success";
    return this.type === SUCCESS_STATUS;
  }

  onCloseClicked(): void {
    this.close.emit();
  }
}
